import type { LifeMomentBase } from '@models/life-moment';

export const sortLifeMomentsByLabel = <L extends LifeMomentBase>(lifeMoments: L[]): L[] => {
  return [...lifeMoments].toSorted((a, b) => a.label.localeCompare(b.label));
};
